import { render, staticRenderFns } from "./FacilitiesList.vue?vue&type=template&id=ff458d04&"
import script from "./FacilitiesList.vue?vue&type=script&lang=js&"
export * from "./FacilitiesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports